/** Billing enrollment helpers for add-on purchase flows. */

function positiveId(value: unknown): number | null {
  if (value == null || value === '') return null;
  const n = Number(value);
  if (Number.isNaN(n) || n <= 0) return null;
  return n;
}

/** True when session/API facility row has MCM customer + org for Stripe/OIG checkout. */
export function facilityHasBillingEnrollment(
  facility: Record<string, unknown> | null | undefined,
): boolean {
  if (!facility || typeof facility !== 'object') return false;
  return positiveId(facility.customer_id) !== null && positiveId(facility.org_id) !== null;
}

/** Selected facility id from session storage (`id` or legacy `facility_id`). */
export function facilitySessionId(
  facility: Record<string, unknown> | null | undefined,
): number | undefined {
  const id = positiveId(facility?.id) ?? positiveId(facility?.facility_id);
  return id ?? undefined;
}

export const BILLING_ENROLLMENT_REQUIRED_MESSAGE =
  'This facility is not enrolled for billing yet. Select a facility with an active subscription, or contact contact@unicomply.ai to complete setup.';
